import { render, staticRenderFns } from "./PontoColetaForm.vue?vue&type=template&id=0d289916&scoped=true&"
import script from "./PontoColetaForm.vue?vue&type=script&lang=js&"
export * from "./PontoColetaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d289916",
  null
  
)

export default component.exports